import { createClient } from "@supabase/supabase-js";
import { MockSupabaseClient } from "@/lib/mockSupabase";

const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const IS_MOCK = !(url && anon);

export const supabase = IS_MOCK
  ? new MockSupabaseClient()
  : createClient(url, anon, {
      db: { schema: "public" },
      auth: { autoRefreshToken: true, persistSession: true, detectSessionInUrl: true },
    });
